import { curry } from 'ramda'

import { ImageDto, ImageState, ImageType } from 'api/types'

export const getImageUrlInSize = curry((width: number, image: ImageDto | string): string => {
  const urlTemplate = typeof image === 'string' ? image : image.urlTemplate
  return urlTemplate.toLocaleLowerCase().replace('{width}', String(width))
})
